import { HttpResponse, UserOption as Option } from '@/common/entity.types'
import idbKeys from '@/common/idb-key'
import idb from '@/utils/idb'
import { HttpStatusCode } from '@/common/constant'
import UserOptionAPI from '@/apis/business/common/user-option-api'
import CacheTime from './cache-time'
import { getContextData, ContextDataKey } from '@/utils/context-data'

class UserOption {
  /**
   * @description Lấy ra option của người dùng
   * @param option optionID cần lấy, không truyền lấy hết
   * @returns
   * @author PHNam
   */
  public async GetUserOption (optionID?: string | null): Promise<any> {
    const key = idbKeys.UserOption
    const isExpired = await CacheTime.IsExpiredTime(key)
    let options: Option[] | any[] = isExpired ? [] : await idb.get(key, [])
    // filter width optionID

    const optionByID = options.find((opt: Option) => {
      return (
        opt.OptionID === optionID &&
        opt.UserID === getContextData(ContextDataKey.UserID)
      )
    })

    // Call API lên server lấy dữ liệu khi:
    // + Hết hạn cache
    // + Không có UserOption trong IndexDB
    // + Có UserOption trong IndexDb nhưng key cần lấy ra không có
    const hasOption = await idb.get(key, false)
    if (isExpired || !hasOption || (hasOption && !optionByID)) {
      // doesn't exist on indexeddb
      // @ts-ignore
      const response: HttpResponse = await UserOptionAPI.getUserOption()

      if (response.IsSuccess && response.Code === HttpStatusCode.OK) {
        options = response.Data

        await idb.set(key, options)
        await CacheTime.SetCacheTime(key)
      }
    }

    return optionID
      ? options.find((opt: Option) => {
        return (
          opt.OptionID === optionID &&
            opt.UserID === getContextData(ContextDataKey.UserID)
        )
      })
      : options
  }

  /**
   * @description Lưu option xuống db và set lại trong IndexedDB
   * @param option
   * @author PHNam
   */
  public async SaveUserOption (option: Option): Promise<boolean> {
    // @ts-ignore
    const response: HttpResponse = await UserOptionAPI.addUserOption(option)
    const key = idbKeys.UserOption
    const optionRes = response.Data
    let isSuccess = false

    if (response.IsSuccess && response.Code === HttpStatusCode.OK) {
      let userOptions: Option[] = await this.GetUserOption()

      userOptions = userOptions.filter(
        (opt) => opt.OptionID !== option.OptionID
      )
      userOptions.push(optionRes)
      await idb.set(key, userOptions)
      await CacheTime.SetCacheTime(key)
      isSuccess = true
    }

    return isSuccess
  }
}
export default new UserOption()
